<TheNavbarVue></TheNavbarVue><router-view></router-view><TheFooterVue></TheFooterVue>